import { Component, OnInit, Type, ChangeDetectionStrategy, EventEmitter, Output, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LicenseService } from 'app/core/services/license.service';
import { Observable } from 'rxjs/Observable';
import { Subscription, Subject, ReplaySubject } from 'rxjs';
import { NotificationService } from 'app/core/services/notification.service';
import { SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';
import { ContentUpdatedInfoEdcastComponent } from 'app/shared/components/modal/content-updated-info-edcast/content-updated-info-edcast.component';
import { CardConfigurationService } from 'app/core/components/workflow-new/course/configurations/card-configuration.service';
import { CardConfiguration } from 'app/core/components/workflow-new/course/configurations/card-configuration';
import { ProfileService } from 'app/core/components/profile/profile.service';
import { CertificateService } from 'app/core/components/content/certificate/certificate.service';
import { MaterialStackContainerService } from 'app/core/components/workflow-new/material/material-stack-container/material-stack-container.service';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { DomainService } from 'app/core/services/domain.service';

@Component({
  selector: 'itpx-evaluation-material-stack-presentation',
  templateUrl: './evaluation-material-stack-presentation.component.html',
  styleUrls: ['../../../workflow-new/common/style.css', '../../../workflow-new/material/material-stack-presentation/material-stack-presentation.component.css']
})
export class EvaluationMaterialStackPresentationComponent extends RxComponent implements OnInit {
  // @Output() private checkForUpdates$ = new EventEmitter<string>();
  private eLearningCertificates: any[];
  private backgroundUrl$: Observable<string>;
  private classConfig: CardConfiguration;
  private platformClass: any;
  private sub: Subscription;
  private deliverables$ = new ReplaySubject<Array<any>>(1);
  private certificates: Array<any>;
  private errorMessage: String;
  private openModal = new Subject<any>();
  private updateContent = new Subject<any>();
  private tab: string;
  // private update = new Subject<any>();
  private classInfo = new Subject<any>();
  profile: any;

  @Input() materialDetails$: Observable<any>;
  @Input() state$: Observable<string>;


  constructor(private licenseService: LicenseService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
    private profileService: ProfileService,
    private certificateService: CertificateService,
    private modalService: SmartModalService,
    private cardConfiguration: CardConfigurationService,
    private domainService: DomainService
  ) {
    super();
  }

  ngOnInit() {
    this.tab = 'content';
    this.backgroundUrl$ = this.domainService.getBanner();
    this.materialDetails$.bindToLifecycle(this).subscribe(details => {
      this.platformClass = details.material;
      this.eLearningCertificates = details.eLearningCertificates;
      this.classConfig = this.cardConfiguration.getConf(this.platformClass);
      this.classConfig.links = [ ];
      this.classConfig.clickable = false;
      this.classConfig.imageHeight = '200';
      this.classConfig.imageWidth = '200';
      this.classConfig.cardHeight = '250';
      this.deliverables$.next(details.learnerDeliverables);
    });
  }

  private onTabClicked(tab: string) {
    if (tab === 'achievements' && 0 === this.eLearningCertificates.length)
      return;
    this.tab = tab;
  }
}




// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/workflow_new/evaluation-material-stack-presentation/evaluation-material-stack-presentation.component.ts